import React, { useEffect } from 'react'
import play from '../../assets/images/player/play.svg'
import pause from '../../assets/images/player/pause.svg'

function SongPlayPause(props) {
  
  function playPauseSong() {
    let currentSong = document.getElementById(`player-source`),
        playPauseIcon = document.getElementById(`song-play-pause`)
    
    if (currentSong.paused) {
      currentSong.play()
      playPauseIcon.style.maskImage = `url(${pause})`
      playPauseIcon.style.WebkitMaskImage = `url(${pause})`
    } else {
      currentSong.pause()
      playPauseIcon.style.maskImage = `url(${play})`
      playPauseIcon.style.WebkitMaskImage = `url(${play})`
    }
  }
  
  const handleKeyDown = (e) => {
    if (e.key === `k`) {
      playPauseSong()
    }
  }
  
  useEffect(() => {
    document.addEventListener(`keydown`, handleKeyDown)

    return () => document.removeEventListener(`keydown`, handleKeyDown)
  })
  
  return (
    <button id={`song-play-pause`} onClick={playPauseSong} style={{maskImage: `url(${play})`, WebkitMaskImage: `url(${play})`}}>Play / Pause</button>
  )
}

export default SongPlayPause